import * as React from 'react';

function SvgPlusCircle() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={49.55}
      height={49.55}
      viewBox="0 0 49.55 49.55">
      <defs>
        <style>{'.prefix__a{fill:#dfdfdf}'}</style>
      </defs>
      <path
        className="prefix__a"
        d="M35.554 22.869h-8.876v-8.874a1.906 1.906 0 10-3.812 0v8.874h-8.871a1.825 1.825 0 00-1.905 1.909 1.845 1.845 0 001.905 1.9h8.874v8.874a1.846 1.846 0 001.909 1.908 1.9 1.9 0 001.9-1.906v-8.876h8.874a1.906 1.906 0 000-3.812z"
      />
      <path
        className="prefix__a"
        d="M24.775 3.335a21.443 21.443 0 0115.163 36.6A21.443 21.443 0 019.612 9.612a21.3 21.3 0 0115.163-6.277m0-3.335A24.775 24.775 0 1049.55 24.775 24.771 24.771 0 0024.775 0z"
      />
    </svg>
  );
}

export default SvgPlusCircle;
